import React from 'react';
import PaginationButton from '../pagination-button';
import PaginationDots from '../pagination-dots';
import getVisiblePages from '../../helpers/get-visible-pages';
import { WHEN_DOTS_ARE_HIDDEN } from '../../constants';

const PaginationButtons = ({ pages, currentPage, disabled = false, setPage }) => {
  const firstPage = pages[0];
  const lastPage = pages[pages.length - 1];

  return (
    <React.Fragment>
      <PaginationButton
        label={String(firstPage)}
        selected={currentPage === firstPage}
        disabled={disabled}
        onClick={() => setPage(firstPage)}
      />
      {currentPage > WHEN_DOTS_ARE_HIDDEN && <PaginationDots />}
      {getVisiblePages(pages, currentPage).map((page) => (
        <PaginationButton
          key={page}
          label={String(page)}
          selected={currentPage === page}
          disabled={disabled}
          onClick={() => setPage(page)}
        />
      ))}
      {currentPage <= pages.length - WHEN_DOTS_ARE_HIDDEN && <PaginationDots />}
      <PaginationButton
        label={String(lastPage)}
        selected={currentPage === lastPage}
        disabled={disabled}
        onClick={() => setPage(lastPage)}
      />
    </React.Fragment>
  );
};

export default PaginationButtons;
